import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "react-feather";
import numberFormat from "lib/numberFormat";
import TaxReport from "components/TaxReport";
export default function AdminReport(props) {
  return (
    <>
      <div class="col-span-12 mt-8">
        <div class="intro-y flex items-center h-10">
          <h2 class="text-lg font-medium truncate mr-5">گزارش کلی مدیر</h2>
        </div>
        <TaxReport />
        <div class="grid grid-cols-12 gap-6 mt-5">
          <CardItem
            icon={<Icons.Phone class="report-box__icon text-theme-10" />}
            title="تعداد اشتراک ایرانسل"
            value={numberFormat.putCommas(props.data.count_of_mtn_subscription)}
          />
        </div>
        <div class="grid grid-cols-12 gap-6 mt-5">
          <CardItem
            icon={<Icons.Users class="report-box__icon text-theme-10" />}
            title="تعداد کاربران"
            value={numberFormat.putCommas(props.data.users_count)}
          />
          <CardItem
            icon={<Icons.Package class="report-box__icon text-theme-10" />}
            title="تعداد اشتراک فعال"
            value={numberFormat.putCommas(
              props.data.count_of_active_subscription
            )}
          />
          <CardItem
            icon={<Icons.Package class="report-box__icon text-theme-10" />}
            title="تعداد اشتراک خریداری شده"
            value={numberFormat.putCommas(
              props.data.count_of_sold_subscription
            )}
          />

          <CardItem2
            icon={<Icons.DollarSign class="report-box__icon text-theme-10" />}
            title="فروش کل امروز"
            value={props.data.sales_today}
          />
          <CardItem2
            icon={<Icons.DollarSign class="report-box__icon text-theme-10" />}
            title="فروش کل 7 روز گذشته"
            value={props.data.sales_7_days_ago}
          />
          <CardItem2
            icon={<Icons.DollarSign class="report-box__icon text-theme-10" />}
            title="فروش کل 30 روز گذشته"
            value={props.data.sales_30_days_ago}
          />

          <CardList
            title="پر فروش ترین فیلم ها"
            list={props.data.best_selling_movies}
          />
          <CardList
            title="پر فروش ترین پکیج ها"
            list={props.data.best_selling_packages}
          />
          <CardList
            title="پر فروش ترین اکران ها"
            list={props.data.best_selling_screening}
          />

          <CardItem2
            icon={<Icons.DollarSign class="report-box__icon text-theme-10" />}
            title="فروش اشتراک امروز"
            value={props.data.sales_subscription_1_days_ago}
          />
          <CardItem2
            icon={<Icons.DollarSign class="report-box__icon text-theme-10" />}
            title="فروش اشتراک 7 روز گذشته"
            value={props.data.sales_subscription_7_days_ago}
          />
          <CardItem2
            icon={<Icons.DollarSign class="report-box__icon text-theme-10" />}
            title="فروش اشتراک 30 روز گذشته"
            value={props.data.sales_subscription_30_days_ago}
          />

          <CardItem2
            icon={<Icons.DollarSign class="report-box__icon text-theme-10" />}
            title="فروش فیلم امروز"
            value={props.data.sales_movies_1_days_ago}
          />
          <CardItem2
            icon={<Icons.DollarSign class="report-box__icon text-theme-10" />}
            title="فروش فیلم 7 روز گذشته"
            value={props.data.sales_movies_7_days_ago}
          />
          <CardItem2
            icon={<Icons.DollarSign class="report-box__icon text-theme-10" />}
            title="فروش فیلم 30 روز گذشته"
            value={props.data.sales_movies_30_days_ago}
          />

          <CardItem2
            icon={<Icons.DollarSign class="report-box__icon text-theme-10" />}
            title="فروش بلیت امروز"
            value={props.data.sales_screening_1_days_ago}
          />
          <CardItem2
            icon={<Icons.DollarSign class="report-box__icon text-theme-10" />}
            title="فروش بلیت 7 روز گذشته"
            value={props.data.sales_screening_7_days_ago}
          />
          <CardItem2
            icon={<Icons.DollarSign class="report-box__icon text-theme-10" />}
            title="فروش بلیت 30 روز گذشته"
            value={props.data.sales_screening_30_days_ago}
          />
        </div>
      </div>
    </>
  );
}

export function CardItem(props) {
  return (
    <div
      class="col-span-12 sm:col-span-6 xl:col-span-4 intro-y"
      style={{ zIndex: 3 }}
    >
      <div class="report-box zoom-in">
        <div class="box p-5">
          <div class="flex">
            {props.icon}

            <div class="mr-auto">
              <div class="report-box__indicator bg-theme-9 tooltip cursor-pointer"></div>
            </div>
          </div>
          <div class="text-3xl font-medium leading-8 mt-6">{props.value} </div>
          <div class="text-base text-gray-600 mt-1">{props.title}</div>
        </div>
      </div>
    </div>
  );
}
export function CardItem2(props) {
  return (
    <div class="col-span-12 sm:col-span-6 xl:col-span-4 intro-y">
      <div class="report-box zoom-in">
        <div class="box p-5">
          <div class="flex">
            {props.icon}
            <div class="mr-auto">
              <div
                class="report-box__indicator bg-theme-9 tooltip cursor-pointer"
                // title={"%۱۰" + " بیشتر از ماه پیش"}
              ></div>
            </div>
          </div>
          <div class="text-xl font-medium leading-8">
            {numberFormat.putCommas(props.value.IRR)} {"  تومان "}
          </div>
          <div class="text-xl font-medium leading-8">
            {numberFormat.putCommas(props.value.USD)} {"  دلار "}
          </div>
          <div class="text-base text-gray-600 mt-1">{props.title}</div>
        </div>
      </div>
    </div>
  );
}
export function CardList(props) {
  return (
    <div class="col-span-12 sm:col-span-6 xl:col-span-4 box">
      <div class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200">
        <h2 class="font-medium text-base ml-auto">{props.title}</h2>
      </div>
      <div class="p-5">
        <div class="preview">
          <div class="overflow-x-auto">
            <table class="table text-center">
              <tbody>
                {props.list &&
                  props.list.length > 0 &&
                  props.list.map((item) => (
                    <tr class="bg-gray-200 dark:bg-dark-1">
                      <td class="border-b dark:border-dark-5">
                        {item.title || item.name}
                      </td>
                      <td class="border-b dark:border-dark-5">
                        <span className="rounded-full bg-gray-300 p-1 dark:text-gray-800">
                          {item.sell_count}
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
